export const translations = {
    labelButtonAbortItemLoad: '',
    labelButtonAbortItemProcessing: '',
    labelButtonProcessItem: '',
    labelButtonRemoveItem: '',
    labelButtonRetryItemLoad: '',
    labelButtonRetryItemProcessing: '',
    labelButtonUndoItemProcessing: '',
    labelDecimalSeparator: '',
    labelFileLoadError: '',
    labelFileLoading: '',
    labelFileProcessing: '',
    labelFileProcessingAborted: '',
    labelFileProcessingComplete: '',
    labelFileProcessingError: '',
    labelTapToCancel: '',
    labelFileSizeNotAvailable: '',
    labelFileWaitingForSize: '',
    labelIdle: 'Перетягніть файл сюди, або натисніть ТУТ для вибору',
    labelTapToRetry: '',
    labelTapToUndo: '',
    labelThousandsSeparator: '',
};
